<template>
	<div class="layout_left_menu">
		<div v-for="item in menuList1" :key="item.id" @click="clickMenuItem(item)">
			<div class="layout_menu_item pad0" style="margin-top: 10px;">
				<img :src="require(`/src/assets/aside/layout_menu_menu${item.img}.png`)"
					style="width: 100%;height: 100%;" alt="" />
			</div>
		</div>

		<div style="margin-top: 12px;" @click="clickTabList()">
			<div class="layout_menu_item" style="margin-top: 6px;">
				<img src="../../../assets/icons/game.png" class="layout_menu_item_icon" alt="" />
				<div class="layout_menu_item_name">All Games</div>
				<img class="layout_menu_item_right_icon" src="../../../assets/icons/right_icon.png" alt="" />
			</div>
		</div>

		<div class="layout_menu_item_box">
			<div v-for="(item,index) in menuList2" :key="index" @click="clickMenuItem(item)">
				<div class="layout_menu_item">
					<img :src="require(`/src/assets/aside/layout_menu_icon${item.icon}.png`)"
						class="layout_menu_item_icon" alt="" />
					<div class="layout_menu_item_name">
						{{item.name}}
					</div>
					<img class="layout_menu_item_right_icon" src="../../../assets/icons/right_icon.png" alt="" />
				</div>
			</div>
		</div>
		<div class="layout_menu_item_box">
			<div v-for="(item,index) in menuList3" :key="item.id" @click="clickMenuItem(item)">
				<div class="layout_menu_item">
					<img :src="require(`/src/assets/aside/layout_menu_icon${item.icon}.png`)"
						class="layout_menu_item_icon" alt="" />
					<div class="layout_menu_item_name">
						{{item.name}}
					</div>
					<img class="layout_menu_item_right_icon" src="../../../assets/icons/right_icon.png" alt="" />
				</div>
			</div>
		</div>

		<div class="layout_menu_item" style="margin-top: 12px;">
			<img :src="require(`/src/assets/aside/layout_menu_icon12.png`)" class="layout_menu_item_icon" alt="" />
			<div class="layout_menu_item_name">
				English
			</div>
			<!-- <img class="layout_menu_item_right_icon" src="../../../assets/icons/right_icon.png" alt="" /> -->
		</div>

		<img @click="toDown" class="layout_menu_item_icon_down" src="../../../assets/image/down.png" alt="" />
		<!-- <div class="layout_share" style="margin-top: 12px;">
			<div class="layout_share_title">
				Follow us on:
			</div>
			<div class="layout_share_menu">
				<div class="layout_share_menu_item" v-for="item in medialList" @click="clickShare(item)" :key="item.id">
					<img :src="item.mediaIcon" class="layout_share_menu_item_icon" alt="" />
				</div>
			</div>
		</div> -->


		<!-- 加盟 -->
		<joinDialog :show="joinDialogShow" @close="joinDialogShow=false" :curTabs="curTabs"></joinDialog>

		<!-- 大转盘 -->
		<luckyWheelPage :show="luckyWheelShow" @close="luckyWheelShow=false"></luckyWheelPage>

		<!-- 退出登录 -->
		<logOutDialog :show="logOutShow" @close="logOutShow=false"></logOutDialog>

		<!-- 签到弹窗 -->
		<!-- <signinDialog :show="signInShow" @close="signInShow=false"></signinDialog> -->


		<!-- 游戏收藏 -->
		<favoritesPage :show="favoritesShow" url="gameCollectList" @close="favoritesShow=false"></favoritesPage>

		<!-- 防沉迷 -->
		<selfExDialog :show="selfExShow" url="gameCollectList" @close="selfExShow=false"></selfExDialog>
		
		
	</div>
</template>
<script>
	import {
		mapState,
	} from 'vuex';
	import signinDialog from './signinDialog.vue'
	import joinDialog from './joinDialog.vue'
	import logOutDialog from './logOutDialog.vue'
	import luckyWheelPage from './luckyWheelPage.vue'
	import favoritesPage from './favoritesPage.vue'
	import selfExDialog from './selfExDialog.vue'

	export default {
		components: {
			signinDialog,
			joinDialog,
			logOutDialog,
			luckyWheelPage,
			favoritesPage,
			selfExDialog,
		},
		computed: {
			...mapState(['user', 'token','selfType']), // 映射 user 模块下的 userInfo 状态
		},
		data() {
			return {
				joinDialogShow: false, //加盟面板是否显示
				logOutShow: false, //是否显示退出
				luckyWheelShow: false, //大转盘是否显示
				favoritesShow: false,//收藏的游戏列表
				selfExShow: false,//防沉迷
				medialList:[],
				signInShow: false, //签到弹框

				curTabs:1,
				tabList: [
					{ name: 'All Games', img: '/static/home/game.png', url: '' },
				],
				menuList1: [
					// {
					// 	id: 1,
					// 	name: '',
					// 	url: '',
					// 	icon: '',
					// 	img: '1',
					// 	remark: '转盘',
					// },
					{
						id: 4,
						name: '',
						url: 'DailyLuckySpinPage',
						icon: '',
						img: '4',
						remark: '',
					},
					{
						id: 5,
						name: '',
						url: 'DepositSpinPage',
						icon: '',
						img: '5',
						remark: '',
					},
					{
						id: 6,
						name: '',
						url: 'BettingSpinPage',
						icon: '',
						img: '6',
						remark: '',
					},
					{
						id: 2,
						name: '',
						url: '',
						icon: '',
						img: '2',
						remark: '',
					},
					{
						id: 3,
						name: '',
						url: 'SignInPage',
						icon: '',
						img: '3',
						remark: '',
					},
				],
				menuList2: [{
						id: 7,
						name: 'Favorites',
						url: '',
						icon: 5,
						img: 'layout_menu_menu2.png',
						remark: '',
					},
					{
						id: 8,
						name: 'Promotions',
						url: 'promotions',
						icon: 6,
						img: 'layout_menu_menu2.png',
						remark: '',
					},
					// 隐藏联盟菜单
					// {
					// 	id: 9,
					// 	name: 'Affiliate',
					// 	url: '',
					// 	icon: 7,
					// 	img: 'layout_menu_menu2.png',
					// 	remark: '',
					// },
				],
				menuList3: [{
						id: 10,
						name: 'Settings',
						url: 'setpage',
						icon: 5,
						img: 'layout_menu_menu2.png',
						remark: '',
						type: 2,
					},
					// {
					// 	id: 11,
					// 	name: 'Support',
					// 	url: 'setpage',
					// 	icon: 8,
					// 	img: 'layout_menu_menu2.png',
					// 	remark: '',
					// 	type: 2,
					// },
					{
						id: 12,
						name: 'Help Center',
						url: 'faqpage',
						icon: 9,
						img: 'layout_menu_menu2.png',
						remark: '',
					},
					{
						id: 13,
						name: 'Self Ex.',
						url: '',
						icon: 10,
						img: 'layout_menu_menu2.png',
						remark: '',
					},
				],
			}
		},
		props: {
			isCollapse: {
				default: true
			},
		},
		mounted() {
			this.getClassList()
			this.getMediaList()
		},
		methods: {
			navTo(url, que = {}) {
				this.$router.push({
					name: url,
					query: que
				})
			},
			// 获取分类列表
			getClassList() {
				this.$api.getClassList({}).then(res => {
					this.tabList = res.data
				})
			},
			getMediaList(){
				this.$api.getList({}).then(res => {
					this.medialList = res.data
					
				})
			},
			clickShare(value){
				window.open(value.mediaUrl, '_blank', 'noopener,noreferrer');
			},
			clickTabList(item) {
				this.navTo('homePage', {
					type:'0'
				})
			},
			toDown(){
				this.navTo('down')
			},
			clickMenuItem(item) {
				const noAuthRequired = ['login', 'register'].includes(item.url) || item.id === 4|| item.id === 5|| item.id === 6 || item.id === 8 || item.id === 12;
				if (!noAuthRequired && !this.token) {
				this.$router.push({ path: 'login' });
				return;
			}
  
				if (item.id == 1) {
					// this.luckyWheelShow = true
				} else if (item.id == 2) {
					this.$router.push({ path: 'referral' });
					// 隐藏联盟
					// this.curTabs = 2
					// this.joinDialogShow = true
				}
				// else if (item.id == 3) {
				// 	// 邀请奖励
				// 	// this.signInShow = true
				// 	// this.$router.push({ name: 'SignInPage' });
				// 	this.signInShow = true
				// 	// 隐藏联盟
				// 	// this.curTabs = 2
				// 	// this.joinDialogShow = true
				// }
				 else if (item.id == 7) {
					// 收藏列表
					this.favoritesShow = true
				} else if (item.id == 9) {
					this.joinDialogShow = true
				} else if (item.url) {
					this.navTo(item.url, {
						type: item.type
					})
				} else if (item.id == 13) {
					if(!this.user.email&&!this.user.phonenumber){
						this.$use.msg('Please bind your mobile phone number and email address first','error')
					}else{
						if(this.selfType.status&&this.selfType.status!='0'){
							this.$store.dispatch('setSelfShow',true)
						}else{
							this.selfExShow = true
						}
					}
				}
			},
			

		}
	}
</script>
<style>
	.layout_left_menu {
		width: 204px;
		min-width: 204px;
		/* height: calc(100vh - 98px); */
		height: 100vh;
		border-radius: 0px 0px 0px 0px;
		background-color: #08090D !important;
		box-sizing: border-box;
		padding: 20px 0 80px;
		display: flex;
		flex-direction: column;
		align-items: center;
		overflow-y: auto;
		/* 隐藏滚动条 */
		-ms-overflow-style: none;
		scrollbar-width: none;
	}

	.pad0 {
		padding: 0 !important;
	}

	.layout_menu_item_box {
		background: #1F242F;
		border-radius: 6px;
		margin-top: 12px;
		box-sizing: border-box;

		.layout_menu_item {
			height: 55px;
		}
	}

	.layout_menu_item {
		width: 174px;
		height: 43px;
		min-height: 43px;
		background: #1F242F;
		border-radius: 6px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 16px;
		box-sizing: border-box;
		cursor: pointer;
	}

	.layout_menu_item_icon_down {
		width: 174px;
		height: 43px;
		margin-top: 12px;
	}

	.layout_menu_item_icon {
		width: 22px;
		height: 22px;

	}

	.layout_menu_item_name {
		flex: 1;
		margin-left: 16px;
		color: #A2B4D1;
		font-size: 14px;
		font-weight: 500;
	}

	.layout_menu_item_right_icon {
		width: 19.06px;
		height: 18px;
	}

	.layout_share {
		width: 174px;
		height: 96px;
		min-height: 96px;
		background: #1F242F;
		border-radius: 8px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		box-sizing: border-box;
		padding: 0 12px;
	}

	.layout_share_title {
		font-size: 15px;
		color: #A2B4D1;
		font-weight: 500;
	}

	.layout_share_menu {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-top: 16px;
	}

	.layout_share_menu_item_icon {
		width: 24px;
		height: 24px;
	}
</style>